export default __webpack_public_path__ + "img/team-4-470x470.4ef82ef4.png";